export default "__VITE_ASSET__BHPIb4c4__"